import React, {Component} from 'react'
import PartnerPage from './PartnerPage'

class PartnerContainer extends Component {
    render() {
        const {id} = this.props.match.params

        return (
            <div className="PartnerContainer">
                <PartnerPage id={id}/>
            </div>
        )
    }
}

export default PartnerContainer